import React from 'react';
import classNames from 'classnames/bind';

import styles from './MainHeroMassage.module.scss';

let cx = classNames.bind(styles);

const MainHeroMassage = () => {
	return (
		<section id='inicio' className={cx({ main_hero: true })}>
			<div className='h-auto flex flex-col justify-center items-center lg:flex-row lg:justify-center lg:items-center'>
				<div
					className={cx({
						trans_box: true,
						'flex flex-col px-10 pt-16': true,
					})}
				></div>
			</div>
		</section>
	);
};

export default MainHeroMassage;
